/* One absolute deadline per sale, shared by every visitor and editor preview. */
if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      if (!this.querySelector('[data-countdown-active]')) {
        this.observer = new MutationObserver(() => {
          if (this.querySelector('[data-countdown-active]')) this.connectedCallback();
        });
        this.observer.observe(this, { childList: true, subtree: true });
        return;
      }
      this.fallback = this.querySelector('[data-countdown-fallback]');
      this.output = this.querySelector('[data-countdown-active]');
      const value = (this.dataset.end || '').trim();
      // Never interpret a merchant's deadline in the visitor's local timezone.
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      if (!this.fallback || !this.output || !Number.isFinite(this.deadline)) return;
      const hours = Number(this.dataset.startHours ?? 72);
      this.startHours = Number.isFinite(hours) && hours >= 0 ? hours : 72;
      this.tick();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() { this.stop(); }
    stop() { clearInterval(this.interval); this.observer?.disconnect(); }

    tick() {
      const remaining = this.deadline - Date.now();
      const active = remaining > 0 && (this.startHours === 0 || remaining <= this.startHours * 60 * 60 * 1000);
      const expired = remaining <= 0 ? (this.dataset.expired || '') : '';
      this.fallback.hidden = active || Boolean(expired);
      this.output.hidden = !active && !expired;
      if (active) {
        const seconds = Math.ceil(remaining / 1000);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        const secs = seconds % 60;
        const label = this.dataset.label || '';
        const days = Math.floor(hours / 24);
        // Automatic format drops days when the final 24 hours begin.
        const showDays = this.dataset.format === 'days' || (this.dataset.format !== 'hours' && remaining > 24 * 60 * 60 * 1000);
        const displayHours = showDays ? hours % 24 : hours;
        if (this.dataset.style === 'blocks') {
          const unitNames = showDays ? ['Days', 'Hrs', 'Mins', 'Secs'] : ['Hrs', 'Mins', 'Secs'];
          const unitValues = showDays ? [days, displayHours, minutes, secs] : [displayHours, minutes, secs];
          if (!this.values || this.values.length !== unitValues.length) {
            this.output.replaceChildren();
            if (label) {
              const caption = document.createElement('span');
              caption.textContent = label;
              this.output.append(caption);
            }
            const units = document.createElement('span');
            units.className = 'sale-countdown__units';
            units.setAttribute('aria-hidden', 'true');
            this.values = unitNames.map(name => {
              const unit = document.createElement('span');
              unit.className = 'sale-countdown__unit';
              const value = document.createElement('span');
              value.className = 'sale-countdown__value';
              const unitLabel = document.createElement('span');
              unitLabel.className = 'sale-countdown__unit-label';
              unitLabel.textContent = name;
              unit.append(value, unitLabel);
              units.append(unit);
              return value;
            });
            this.output.append(units);
          }
          unitValues.forEach((value, index) => {
            this.values[index].textContent = String(value).padStart(2, '0');
          });
        } else {
          this.output.textContent = `${label}${label ? ' ' : ''}${showDays ? String(days).padStart(2, '0') + 'd ' : ''}${String(displayHours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(secs).padStart(2, '0')}s`;
        }
        this.output.setAttribute('aria-label', `${label} ${showDays ? days + ' days, ' : ''}${displayHours} hours, ${minutes} minutes, ${secs} seconds`.trim());
      } else {
        this.values = null;
        this.output.textContent = expired;
        this.output.removeAttribute('aria-label');
      }
      if (remaining <= 0) this.stop();
    }
  });
}
